import axios from "axios";
import { cmsHeaders } from "../exports/exports";

export const fetchActivitiesList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/activities-activities-list`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
